import styled from 'styled-components';

import CrossIcon from '../assets/svg/CrossIcon';

export const CrossIconStyled = styled(CrossIcon)`
  color: #6a6a6a;
  padding: 4px;
  font-size: 14px !important;
  cursor: pointer;
  margin-left: 12px;
  '&:hover': {
    border-radius: 50%;
    background-color: #eeeff2;
  }
`;

export default {};
